import { ApiError } from "@/lib/apiClient";

/**
 * Backend error code: a non-leader tried to set a PPP's `isConfidential` or `memberPids`. The form only
 * sends those two keys for leaders, so this fires when the viewer's role changed mid-session.
 */
export const PPP_CONFIDENTIAL_LEADER_ONLY = "PPP_CONFIDENTIAL_LEADER_ONLY";

/** Returns guidance when the backend refused a confidentiality change, else undefined. */
export function getPppConfidentialMessage(error: unknown): string | undefined {
    if (!(error instanceof ApiError)) return undefined;
    const body = error.body as { message?: string };
    if (body?.message !== PPP_CONFIDENTIAL_LEADER_ONLY) return undefined;

    return "Only leaders can change a PPP's confidentiality.";
}
